import { Bar } from '../charting_library/charting_library';
import { ExtractBar } from '../transferobjects/ExtractBar';
import { apiHistory } from './index';

export function getFirstData(
    symbol: string,
    resolution: number,
    from: number,
    to: number,
    currencyCode: string
): Promise<Array<Bar>> {
    return new Promise<Array<Bar>>((resolve, reject) => {
        console.log(`https://www.binance.com/api/v3/klines?symbol=BTCUSDT&interval=${resolution}m&startTime=${from}&endTime=${to}`)
        fetch(
            `https://www.binance.com/api/v3/klines?symbol=BTCUSDT&interval=${resolution}m&startTime=${from}&endTime=${to}&limit=1000`
        )
            .then((response) => response.json())
            .then((data) => {
                resolve(
                    data.map((item) => {
                        return {
                            time: item[0],
                            open: parseFloat(item[1]),
                            high: parseFloat(item[2]),
                            low: parseFloat(item[3]),
                            close: parseFloat(item[4]),
                            volume: parseFloat(item[5]),
                        };
                    })
                );
            });
    });
}



// WEBPACK FOOTER //
// ./src/services/getFirstData.ts